import { render, staticRenderFns } from "./start-sign.vue?vue&type=template&id=578e34e2&scoped=true"
import script from "./start-sign.vue?vue&type=script&lang=js"
export * from "./start-sign.vue?vue&type=script&lang=js"
import style0 from "./start-sign.vue?vue&type=style&index=0&id=578e34e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578e34e2",
  null
  
)

export default component.exports